export enum EWorkSpace {
  getUserWorkSpaceItems = 'workSpace/getUserWorkSpaceItems',
  getAllCategories = 'workSpace/getAllCategories',
  getAllItems = 'workSpace/getAllItems',
  addUserWorkspaceItem = 'workSpace/addUserWorkspaceItem',
  getUserWorkspaceLevels = 'workSpace/agetUserWorkspaceLevels',
  getUserWorkspaceLevelsFromAdmin = 'workSpace/getUserWorkspaceLevelsFromAdmin',
  getDailyCheck = 'workSpace/getDailyCheck',
}
